import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createVNode as _createVNode, withModifiers as _withModifiers, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "asset-details-container" }
const _hoisted_2 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_3 = {
  class: "spinner-border text-primary",
  role: "status"
}
const _hoisted_4 = { class: "visually-hidden" }
const _hoisted_5 = {
  key: 1,
  class: "alert alert-danger"
}
const _hoisted_6 = {
  key: 2,
  class: "asset-details-wrapper"
}
const _hoisted_7 = { class: "asset-hero" }
const _hoisted_8 = { class: "hero-content" }
const _hoisted_9 = { class: "hero-left" }
const _hoisted_10 = { class: "hero-info" }
const _hoisted_11 = { class: "asset-title" }
const _hoisted_12 = { class: "asset-meta" }
const _hoisted_13 = { class: "meta-item" }
const _hoisted_14 = {
  key: 0,
  class: "meta-item"
}
const _hoisted_15 = { class: "hero-right" }
const _hoisted_16 = { class: "modern-tabs" }
const _hoisted_17 = { class: "tab-content-wrapper" }
const _hoisted_18 = {
  key: 0,
  class: "asset-details-content"
}
const _hoisted_19 = { class: "asset-overview-grid" }
const _hoisted_20 = { class: "asset-overview-chart" }
const _hoisted_21 = { class: "chart-header" }
const _hoisted_22 = { class: "chart-title" }
const _hoisted_23 = { class: "chart-actions" }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = ["disabled"]
const _hoisted_26 = ["disabled"]
const _hoisted_27 = ["disabled"]
const _hoisted_28 = ["disabled"]
const _hoisted_29 = { class: "chart-body" }
const _hoisted_30 = {
  key: 0,
  class: "chart-empty-state"
}
const _hoisted_31 = {
  class: "spinner-border text-primary",
  role: "status"
}
const _hoisted_32 = { class: "visually-hidden" }
const _hoisted_33 = {
  key: 1,
  class: "chart-empty-state"
}
const _hoisted_34 = { class: "chart-empty-text" }
const _hoisted_35 = { class: "asset-overview-side" }
const _hoisted_36 = { class: "asset-tile asset-tile-image" }
const _hoisted_37 = { class: "asset-tile-header" }
const _hoisted_38 = { class: "asset-tile-title" }
const _hoisted_39 = ["title"]
const _hoisted_40 = ["src", "alt"]
const _hoisted_41 = { class: "asset-tile-media-overlay" }
const _hoisted_42 = { class: "asset-tile asset-tile-stats" }
const _hoisted_43 = { class: "asset-tile-header" }
const _hoisted_44 = { class: "asset-tile-title" }
const _hoisted_45 = { class: "asset-stats-grid" }
const _hoisted_46 = { class: "asset-stat" }
const _hoisted_47 = { class: "asset-stat-header" }
const _hoisted_48 = { class: "asset-stat-value" }
const _hoisted_49 = { class: "asset-stat" }
const _hoisted_50 = { class: "asset-stat-header" }
const _hoisted_51 = { class: "asset-stat-value" }
const _hoisted_52 = { class: "asset-stat" }
const _hoisted_53 = { class: "asset-stat-header" }
const _hoisted_54 = { class: "asset-stat-value" }
const _hoisted_55 = { class: "asset-stat" }
const _hoisted_56 = { class: "asset-stat-header" }
const _hoisted_57 = { class: "asset-stat-value" }
const _hoisted_58 = { class: "asset-stat" }
const _hoisted_59 = { class: "asset-stat-header" }
const _hoisted_60 = { class: "asset-stat-value" }
const _hoisted_61 = { class: "asset-stat-header" }
const _hoisted_62 = { class: "asset-stat-value" }
const _hoisted_63 = { class: "asset-stat-header" }
const _hoisted_64 = { class: "asset-stat-value" }
const _hoisted_65 = { class: "asset-stat" }
const _hoisted_66 = { class: "asset-stat-header" }
const _hoisted_67 = { class: "asset-stat-value" }
const _hoisted_68 = { class: "asset-stat-header" }
const _hoisted_69 = { class: "asset-stat-value" }
const _hoisted_70 = { class: "asset-tile asset-tile-info" }
const _hoisted_71 = { class: "asset-tile-header" }
const _hoisted_72 = { class: "asset-tile-title" }
const _hoisted_73 = { class: "asset-info-list" }
const _hoisted_74 = { class: "asset-info-item" }
const _hoisted_75 = { class: "asset-info-label" }
const _hoisted_76 = { class: "asset-info-value" }
const _hoisted_77 = {
  key: 0,
  class: "asset-info-item"
}
const _hoisted_78 = { class: "asset-info-label" }
const _hoisted_79 = { class: "asset-info-value" }
const _hoisted_80 = { class: "asset-info-item" }
const _hoisted_81 = { class: "asset-info-label" }
const _hoisted_82 = { class: "asset-info-value" }
const _hoisted_83 = {
  key: 1,
  class: "asset-info-item"
}
const _hoisted_84 = { class: "asset-info-label" }
const _hoisted_85 = { class: "asset-info-value" }
const _hoisted_86 = { key: 1 }
const _hoisted_87 = { class: "chart-header" }
const _hoisted_88 = { class: "chart-title" }
const _hoisted_89 = { class: "chart-actions" }
const _hoisted_90 = ["disabled"]
const _hoisted_91 = ["disabled"]
const _hoisted_92 = ["disabled"]
const _hoisted_93 = ["disabled"]
const _hoisted_94 = {
  key: 0,
  class: "chart-body"
}
const _hoisted_95 = {
  key: 1,
  class: "chart-body chart-fullscreen-empty"
}
const _hoisted_96 = {
  key: 0,
  class: "chart-empty-state"
}
const _hoisted_97 = {
  class: "spinner-border text-primary",
  role: "status"
}
const _hoisted_98 = { class: "visually-hidden" }
const _hoisted_99 = {
  key: 1,
  class: "chart-empty-state"
}
const _hoisted_100 = { class: "chart-empty-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LineChart = _resolveComponent("LineChart")!
  const _component_AssetGroupHistory = _resolveComponent("AssetGroupHistory")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('components.assetGroupDetails.loading')), 1)
            ])
          ]))
        : (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _cache[16] || (_cache[16] = _createElementVNode("i", { class: "bi bi-exclamation-triangle" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.error), 1)
            ]))
          : (_ctx.asset)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _cache[19] || (_cache[19] = _createElementVNode("div", { class: "asset-icon-wrapper" }, [
                        _createElementVNode("i", { class: "bi bi-hdd-rack-fill" })
                      ], -1)),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("h1", _hoisted_11, _toDisplayString(_ctx.asset.name || _ctx.$t('components.assetGroupDetails.unknownGroup')), 1),
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("span", _hoisted_13, [
                            _cache[17] || (_cache[17] = _createElementVNode("i", { class: "bi bi-upc-scan" }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.getGroupCode()), 1)
                          ]),
                          (_ctx.asset.company)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                                _cache[18] || (_cache[18] = _createElementVNode("i", { class: "bi bi-building" }, null, -1)),
                                _createTextVNode(" " + _toDisplayString(_ctx.asset.company.name), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("button", {
                        class: "btn-back",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                      }, [
                        _cache[20] || (_cache[20] = _createElementVNode("i", { class: "bi bi-arrow-left" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assetGroupDetails.backToList')), 1)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("button", {
                    class: _normalizeClass([{active: _ctx.tabContent === _ctx.TAB_DETAILS }, "tab-btn"]),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setTab(_ctx.TAB_DETAILS)))
                  }, [...(_cache[21] || (_cache[21] = [
                    _createElementVNode("i", { class: "bi bi-info-circle-fill" }, null, -1),
                    _createElementVNode("span", null, "Szczegóły", -1)
                  ]))], 2),
                  _createElementVNode("button", {
                    class: _normalizeClass([{active: _ctx.tabContent === _ctx.TAB_HISTORY }, "tab-btn"]),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setTab(_ctx.TAB_HISTORY)))
                  }, [...(_cache[22] || (_cache[22] = [
                    _createElementVNode("i", { class: "bi bi-clock-history" }, null, -1),
                    _createElementVNode("span", null, "Historia", -1)
                  ]))], 2)
                ]),
                _createElementVNode("div", _hoisted_17, [
                  (_ctx.tabContent === _ctx.TAB_DETAILS)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            (!_ctx.isChartFullscreen)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  (_ctx.chartHasData)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: _normalizeClass(["chart-container", { 'dark-mode': _ctx.isDarkMode }])
                                      }, [
                                        _createElementVNode("div", _hoisted_21, [
                                          _createElementVNode("h3", _hoisted_22, [
                                            _cache[23] || (_cache[23] = _createElementVNode("i", { class: "bi bi-graph-up" }, null, -1)),
                                            _createElementVNode("span", null, _toDisplayString(_ctx.getChartTitle()), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_23, [
                                            _createElementVNode("button", {
                                              class: "btn btn-custom",
                                              disabled: !_ctx.chartHasData,
                                              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openChartFullscreen && _ctx.openChartFullscreen(...args))),
                                              title: "Pełny ekran"
                                            }, [...(_cache[24] || (_cache[24] = [
                                              _createElementVNode("i", { class: "bi bi-arrows-fullscreen" }, null, -1)
                                            ]))], 8, _hoisted_24),
                                            _createElementVNode("button", {
                                              class: "btn btn-custom",
                                              disabled: !_ctx.chartHasData,
                                              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.resetZoom('asset-chart'))),
                                              title: "Reset zoom"
                                            }, [...(_cache[25] || (_cache[25] = [
                                              _createElementVNode("i", { class: "bi bi-arrow-clockwise" }, null, -1)
                                            ]))], 8, _hoisted_25),
                                            _createElementVNode("button", {
                                              class: "btn btn-custom chart-action-export",
                                              disabled: !_ctx.chartHasData,
                                              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.exportToPng())),
                                              title: "Eksport PNG"
                                            }, [...(_cache[26] || (_cache[26] = [
                                              _createElementVNode("i", { class: "bi bi-filetype-png" }, null, -1)
                                            ]))], 8, _hoisted_26),
                                            _createElementVNode("button", {
                                              class: "btn btn-custom chart-action-export",
                                              disabled: !_ctx.chartHasData,
                                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.exportToJpg())),
                                              title: "Eksport JPG"
                                            }, [...(_cache[27] || (_cache[27] = [
                                              _createElementVNode("i", { class: "bi bi-filetype-jpg" }, null, -1)
                                            ]))], 8, _hoisted_27),
                                            _createElementVNode("button", {
                                              class: "btn btn-custom chart-action-export",
                                              disabled: !_ctx.chartHasData,
                                              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.exportCsv())),
                                              title: "Eksport CSV"
                                            }, [...(_cache[28] || (_cache[28] = [
                                              _createElementVNode("i", { class: "bi bi-filetype-csv" }, null, -1)
                                            ]))], 8, _hoisted_28)
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_29, [
                                          (_openBlock(), _createBlock(_component_LineChart, {
                                            key: _ctx.chartRenderKey,
                                            height: _ctx.chartHeight,
                                            "chart-id": "asset-chart",
                                            "chart-data": _ctx.chartData,
                                            options: _ctx.chartOptions,
                                            plugins: _ctx.chartPlugins
                                          }, null, 8, ["height", "chart-data", "options", "plugins"]))
                                        ])
                                      ], 2))
                                    : (_openBlock(), _createElementBlock("div", {
                                        key: 1,
                                        class: _normalizeClass(["chart-container chart-container-empty", { 'dark-mode': _ctx.isDarkMode }])
                                      }, [
                                        (_ctx.chartLoading)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                              _createElementVNode("div", _hoisted_31, [
                                                _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t('components.assetGroupDetails.loading')), 1)
                                              ])
                                            ]))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                              _cache[29] || (_cache[29] = _createElementVNode("i", { class: "bi bi-graph-up" }, null, -1)),
                                              _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.chartError || _ctx.$t('components.assetGroupDetails.noHistory')), 1)
                                            ]))
                                      ], 2))
                                ], 64))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("div", _hoisted_36, [
                              _createElementVNode("div", _hoisted_37, [
                                _createElementVNode("div", _hoisted_38, [
                                  _cache[30] || (_cache[30] = _createElementVNode("i", { class: "bi bi-image" }, null, -1)),
                                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assetGroupDetails.image')), 1)
                                ]),
                                _createElementVNode("button", {
                                  class: "asset-tile-action",
                                  type: "button",
                                  title: _ctx.$t('components.assetGroupDetails.openImage'),
                                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.openImageModal && _ctx.openImageModal(...args)))
                                }, [...(_cache[31] || (_cache[31] = [
                                  _createElementVNode("i", { class: "bi bi-arrows-fullscreen" }, null, -1)
                                ]))], 8, _hoisted_39)
                              ]),
                              _createElementVNode("div", {
                                class: "asset-tile-media",
                                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.openImageModal && _ctx.openImageModal(...args)))
                              }, [
                                _createElementVNode("img", {
                                  src: _ctx.getAssetImageOrPlaceholder(),
                                  alt: _ctx.asset.name || _ctx.$t('components.assetGroupDetails.imageAlt'),
                                  class: "asset-tile-media-img"
                                }, null, 8, _hoisted_40),
                                _createElementVNode("div", _hoisted_41, [
                                  _cache[32] || (_cache[32] = _createElementVNode("i", { class: "bi bi-arrows-fullscreen" }, null, -1)),
                                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assetGroupDetails.imageHint')), 1)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_42, [
                              _createElementVNode("div", _hoisted_43, [
                                _createElementVNode("div", _hoisted_44, [
                                  _cache[33] || (_cache[33] = _createElementVNode("i", { class: "bi bi-speedometer2" }, null, -1)),
                                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assetGroupDetails.currentParameters')), 1)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_45, [
                                (_ctx.isDevice)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createElementVNode("div", _hoisted_46, [
                                        _createElementVNode("div", _hoisted_47, [
                                          _cache[34] || (_cache[34] = _createElementVNode("i", { class: "bi bi-arrows-move" }, null, -1)),
                                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assets.dataGrids.xAxis')), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.getAxisValue('X_AXIS')), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_49, [
                                        _createElementVNode("div", _hoisted_50, [
                                          _cache[35] || (_cache[35] = _createElementVNode("i", { class: "bi bi-arrows-vertical" }, null, -1)),
                                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assets.dataGrids.yAxis')), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.getAxisValue('Y_AXIS')), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_52, [
                                        _createElementVNode("div", _hoisted_53, [
                                          _cache[36] || (_cache[36] = _createElementVNode("i", { class: "bi bi-arrows-collapse" }, null, -1)),
                                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assets.dataGrids.zAxis')), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.getAxisValue('Z_AXIS')), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_55, [
                                        _createElementVNode("div", _hoisted_56, [
                                          _cache[37] || (_cache[37] = _createElementVNode("i", { class: "bi bi-activity" }, null, -1)),
                                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assets.dataGrids.magnitude')), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_57, _toDisplayString(_ctx.getAxisMagnitude()), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_58, [
                                        _createElementVNode("div", _hoisted_59, [
                                          _cache[38] || (_cache[38] = _createElementVNode("i", { class: "bi bi-activity" }, null, -1)),
                                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assets.dataGrids.magnitudeNoGravity')), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_60, _toDisplayString(_ctx.getAxisMagnitudeNoGravity()), 1)
                                      ])
                                    ], 64))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createElementVNode("div", {
                                        class: "asset-stat",
                                        style: _normalizeStyle({ '--stat-accent': _ctx.getTemperatureColor() })
                                      }, [
                                        _createElementVNode("div", _hoisted_61, [
                                          _cache[39] || (_cache[39] = _createElementVNode("i", { class: "bi bi-thermometer-half" }, null, -1)),
                                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assets.dataGrids.temperature')), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_62, _toDisplayString(_ctx.getTemperature()), 1)
                                      ], 4),
                                      _createElementVNode("div", {
                                        class: "asset-stat",
                                        style: _normalizeStyle({ '--stat-accent': _ctx.getHumidityColor() })
                                      }, [
                                        _createElementVNode("div", _hoisted_63, [
                                          _cache[40] || (_cache[40] = _createElementVNode("i", { class: "bi bi-droplet-half" }, null, -1)),
                                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assets.dataGrids.humidity')), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_64, _toDisplayString(_ctx.getHumidity()), 1)
                                      ], 4),
                                      _createElementVNode("div", _hoisted_65, [
                                        _createElementVNode("div", _hoisted_66, [
                                          _cache[41] || (_cache[41] = _createElementVNode("i", { class: "bi bi-lightning-charge-fill" }, null, -1)),
                                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assets.dataGrids.power')), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_67, _toDisplayString(_ctx.getPowerSupply()), 1)
                                      ]),
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["asset-stat", _ctx.getBatteryStatusClass()])
                                      }, [
                                        _createElementVNode("div", _hoisted_68, [
                                          _cache[42] || (_cache[42] = _createElementVNode("i", { class: "bi bi-battery-charging" }, null, -1)),
                                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assets.dataGrids.batteryStatus')), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_69, _toDisplayString(_ctx.getBatteryStatus()), 1)
                                      ], 2)
                                    ], 64))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_70, [
                              _createElementVNode("div", _hoisted_71, [
                                _createElementVNode("div", _hoisted_72, [
                                  _cache[43] || (_cache[43] = _createElementVNode("i", { class: "bi bi-info-circle" }, null, -1)),
                                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assetGroupDetails.basicInfo')), 1)
                                ])
                              ]),
                              _createElementVNode("ul", _hoisted_73, [
                                _createElementVNode("li", _hoisted_74, [
                                  _createElementVNode("span", _hoisted_75, _toDisplayString(_ctx.$t('components.assetGroupDetails.groupCodeLabel')), 1),
                                  _createElementVNode("span", _hoisted_76, _toDisplayString(_ctx.getGroupCode()), 1)
                                ]),
                                (_ctx.asset.company)
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_77, [
                                      _createElementVNode("span", _hoisted_78, _toDisplayString(_ctx.$t('components.assets.dataGrids.company')), 1),
                                      _createElementVNode("span", _hoisted_79, _toDisplayString(_ctx.asset.company.name), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("li", _hoisted_80, [
                                  _createElementVNode("span", _hoisted_81, _toDisplayString(_ctx.$t('components.assetGroupDetails.lastActivityLabel')), 1),
                                  _createElementVNode("span", _hoisted_82, _toDisplayString(_ctx.getLastActivity()), 1)
                                ]),
                                (_ctx.getLocationDescription() !== '—')
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_83, [
                                      _createElementVNode("span", _hoisted_84, _toDisplayString(_ctx.$t('components.assetGroupDetails.locationLabel')), 1),
                                      _createElementVNode("span", _hoisted_85, _toDisplayString(_ctx.getLocationDescription()), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.tabContent === _ctx.TAB_HISTORY)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                        _createVNode(_component_AssetGroupHistory, {
                          "asset-id": _ctx.asset.id
                        }, null, 8, ["asset-id"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.isChartFullscreen)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["chart-fullscreen-overlay", { 'dark-mode': _ctx.isDarkMode }]),
            onClick: _cache[15] || (_cache[15] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeChartFullscreen && _ctx.closeChartFullscreen(...args)), ["self"]))
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["chart-container chart-container-fullscreen", { 'dark-mode': _ctx.isDarkMode }])
            }, [
              _createElementVNode("div", _hoisted_87, [
                _createElementVNode("h3", _hoisted_88, [
                  _cache[44] || (_cache[44] = _createElementVNode("i", { class: "bi bi-graph-up" }, null, -1)),
                  _createElementVNode("span", null, _toDisplayString(_ctx.getChartTitle()), 1)
                ]),
                _createElementVNode("div", _hoisted_89, [
                  _createElementVNode("button", {
                    class: "btn btn-custom",
                    type: "button",
                    onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.closeChartFullscreen && _ctx.closeChartFullscreen(...args))),
                    title: "Zamknij"
                  }, [...(_cache[45] || (_cache[45] = [
                    _createElementVNode("i", { class: "bi bi-x-lg" }, null, -1)
                  ]))]),
                  _createElementVNode("button", {
                    class: "btn btn-custom",
                    disabled: !_ctx.chartHasData,
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.resetZoom('asset-chart'))),
                    title: "Reset zoom"
                  }, [...(_cache[46] || (_cache[46] = [
                    _createElementVNode("i", { class: "bi bi-arrow-clockwise" }, null, -1)
                  ]))], 8, _hoisted_90),
                  _createElementVNode("button", {
                    class: "btn btn-custom",
                    disabled: !_ctx.chartHasData,
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.exportToPng())),
                    title: "Eksport PNG"
                  }, [...(_cache[47] || (_cache[47] = [
                    _createElementVNode("i", { class: "bi bi-filetype-png" }, null, -1)
                  ]))], 8, _hoisted_91),
                  _createElementVNode("button", {
                    class: "btn btn-custom",
                    disabled: !_ctx.chartHasData,
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.exportToJpg())),
                    title: "Eksport JPG"
                  }, [...(_cache[48] || (_cache[48] = [
                    _createElementVNode("i", { class: "bi bi-filetype-jpg" }, null, -1)
                  ]))], 8, _hoisted_92),
                  _createElementVNode("button", {
                    class: "btn btn-custom",
                    disabled: !_ctx.chartHasData,
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.exportCsv())),
                    title: "Eksport CSV"
                  }, [...(_cache[49] || (_cache[49] = [
                    _createElementVNode("i", { class: "bi bi-filetype-csv" }, null, -1)
                  ]))], 8, _hoisted_93)
                ])
              ]),
              (_ctx.chartHasData)
                ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                    (_openBlock(), _createBlock(_component_LineChart, {
                      key: _ctx.chartRenderKey,
                      height: _ctx.fullscreenChartHeight,
                      "chart-id": "asset-chart",
                      "chart-data": _ctx.chartData,
                      options: _ctx.chartOptions,
                      plugins: _ctx.chartPlugins
                    }, null, 8, ["height", "chart-data", "options", "plugins"]))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_95, [
                    (_ctx.chartLoading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                          _createElementVNode("div", _hoisted_97, [
                            _createElementVNode("span", _hoisted_98, _toDisplayString(_ctx.$t('components.assetGroupDetails.loading')), 1)
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_99, [
                          _cache[50] || (_cache[50] = _createElementVNode("i", { class: "bi bi-graph-up" }, null, -1)),
                          _createElementVNode("div", _hoisted_100, _toDisplayString(_ctx.chartError || _ctx.$t('components.assetGroupDetails.noHistory')), 1)
                        ]))
                  ]))
            ], 2)
          ], 2))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}